import { render, staticRenderFns } from "./ReportAnnulmentDetails.vue?vue&type=template&id=e2fce178&"
import script from "./ReportAnnulmentDetails.vue?vue&type=script&lang=js&"
export * from "./ReportAnnulmentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports